import { Frame } from '@shared/components/Frame';

export const MainLayout = () => {
  return <Frame title="Simpallo" />;
};
